module.exports = __webpack_public_path__ + "img/headers-templates.b36b94bc.png";